// import { executeQuery } from '../../utilities/AppSyncPlusAPIs';
import { executeQuery } from "src/utilities/AppSyncPlusAPIs";
import { getQueryInput } from 'src/Ateam-BI/Templates/Utils/AppActivityUtils';


export const insertCruzerJobSchedule = async (payload, onSuccess, onFailure) => {
  executeQuery(
    `mutation InsertCruzerJobSchedule {
      insertCruzerJobSchedule(input: {${getQueryInput(payload, [])}})
    }`,
    onSuccess,
    onFailure
  );
};

export const editCruzerJobSchedule = async (payload, onSuccess, onFailure) => {
  executeQuery(
    `mutation EditCruzerJobSchedule {
      editCruzerJobSchedule(input: {${getQueryInput(payload, [])}})
    }`,
    onSuccess,
    onFailure
  );
};

export const listAllCruzerSchedules = async (app_id, onSuccess, onFailure) => {
  var mQry = `query MyQuery {
    listAllCruzerSchedules${app_id ? `(app_id: "${app_id}")` : ''} {
      schedule_id
      job_id
      schedule_name
      schedule_type
      schedule_config
      cron_expression
      description
      daily_schedule_count
      event_bridge_schedule_id
      reference_id
      is_active
      created_by
      created_at
      last_updated_by
      last_updated_at
      target_type
      target_identifier
      target_payload
      app_ids
      begin_schedule_on
    }
  }`

  executeQuery(mQry, onSuccess, onFailure);
};

export const listQSIngestions = async (dataset_id, onSuccess, onFailure, next_token = null) => {
  const variables = { dataset_id };
  if (next_token) variables.next_token = next_token;
  executeQuery(
    `query ListQSIngestions($dataset_id: String!, $next_token: String) {
      listQSIngestions(dataset_id: $dataset_id, next_token: $next_token)
    }`,
    onSuccess,
    onFailure,
    variables
  );
};

export const deleteCruzerJobSchedule = async (deleteInput, onSuccess, onFailure) => {
  executeQuery(
    `mutation DeleteCruzerJobSchedule {
      deleteCruzerJobSchedule(input: {${getQueryInput(deleteInput, [])}}) {
        message
        schedule_id
        job_metadata_deleted
      }
    }`,
    onSuccess,
    onFailure
  );
};
